<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@800&display=swap");

.img-hero-results {
  background-image: url("../assets/Hero5.png");
  background-size: cover;
  background-repeat: no-repeat;
  height: 500px;
  width: 100%;
  margin-top: 30px;
}

.green-background {
  background-color: #57f3bb;
  padding-top: 50px;
  padding-bottom: 50px;
}
.big-title-book {
  font-weight: bold;
  color: #3d4053;
  font-family: "Montserrat";
  font-size: 60px;
  margin-top: 210px;
  text-transform: capitalize;
}

.small-title {
  font-size: 36px;
  font-weight: 600;
  font-family: "Montserrat";
  text-transform: capitalize;
}

.titlel-top {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  align-content: center;
  margin-top: 30px;
  text-transform: capitalize;
}

.titlel-top h1 {
  font-weight: bold;
  font-size: 158px;
  color: #fff;
  font-family: "SofiaProBoldAz";
}

.titlel-top h2 {
  font-weight: bold;
  font-family: "SofiaProBoldAz";
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 114.19%;
  color: #000;
}

.titlel-top h3 {
  font-weight: bold;
  font-family: "SofiaProLightAz";
  font-style: normal;
  font-weight: 400;
  font-size: 40px;
  line-height: 114.19%;
  color: #000;
}

.middle-title {
  margin-top: 100px;
  margin-bottom: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
}

.middle-title h2 {
  font-weight: bold;
  font-family: "SofiaProBoldAz";
  font-style: normal;
  font-weight: bold;
  font-size: 50px;
  line-height: 114.19%;
  color: #3d4053;
  margin-top: 30px;
}

.middle-title h3 {
  font-weight: bold;
  font-family: "SofiaProLightAz";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 114.19%;
  color: #3d4053;
}

.form-section {
  width: 100%;
  margin-top: 50px;
  margin-bottom: 50px;
}

#main-container {
  margin-top: 100px;
}

iframe {
  width: 100%;
  height: 700px;
}

.form-top {
  display: flex;
  flex-direction: column;
  margin-bottom: 30px;
  margin-right: 15px;
  margin-left: 15px;
}

.form-title {
  font-size: 36px;
  font-weight: bold;
  letter-spacing: 0px;
  color: #ffffff75;
}

.form-subtitle {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0px;
  color: #ffffff75;
}

.form-group {
  display: flex;
}

.form-group label {
  font-size: 14px;
  font-family: "SofiaProMediumAz";
  font-weight: bold;
  letter-spacing: 0px;
  color: #000000;
  text-align: left;
  display: flex;
  margin-top: 15p;
  margin-bottom: 15px;
  height: 50px;
  display: flex;
  align-items: center;
  align-content: center;
}

.select-list {
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 600;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.select-list option {
  font-weight: 600;
  color: #495057;
}

.btn-section {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  align-content: center;
  border-top: solid 1px rgb(61, 64, 83, 0.3);
  margin-top: 40px;
}

.btn-submit {
  margin-top: 30px;
  margin-bottom: 15px;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  width: 290px;
  height: 60px;
  border-radius: 17px;
  border: none;
  opacity: 1;
  cursor: pointer;
  outline: none;
  text-decoration: none;

  font-weight: 600;
  font-size: 30px;
  font-family: "Montserrat";
  background: linear-gradient(267.53deg, #ff3ca5 0%, #ca74ff 100%);
  color: #fff;
  text-transform: uppercase;
}

*:focus {
  outline: 0 !important;
}

@media only screen and (max-width: 768px) {
  .img-hero-results {
    background-image: url("../assets/Hero5Mobile.png");
    background-size: contain;
    background-repeat: no-repeat;
    height: 260px;
    width: 100%;
  }
  .big-title-book {
    font-size: 18px;
    margin-left: -40%;
    height: 100px;
  }
  .titlel-top {
    align-items: center;
  }
  .middle-title {
    margin-top: 30px;
    text-align: center;
    align-items: center;
  }
  .middle-title h2 {
    font-size: 30px;
  }
  .titlel-top h1 {
    font-size: 36px;
  }

  .titlel-top h2 {
    font-size: 18px;
  }

  .titlel-top h3 {
    font-size: 14px;
  }
  .form-group {
    display: flex;
    flex-direction: column;
    margin-top: 30px;
    margin-bottom: 30px;
  }

  .form-group label {
    margin-bottom: 15px;
    margin-top: 15px;
    text-align: center;
    justify-content: center;
    height: 30px;
  }
}
</style>

<template>
  <div>
    <MainMenu />
    <div class="container-fluid">
      <div class="container">
        <div class="middle-title">
          <h2>Want to see more? Get a Live Demo</h2>
          <h3>
            Before we schedule a demo we would love to learn more about you
          </h3>
        </div>
        <div class="form-section" id="hubspotForm2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "../router.js";
import { mapState, mapActions } from "vuex";

import MainMenu from "../components/MainMenu";

export default {
  name: "RetailersResults",
  components: {
    MainMenu,
  },
  mounted() {
    this.$nextTick(function () {
      hbspt.forms.create({
        region: "na1",
        portalId: "21143660",
        formId: "6f9857da-2457-43a7-a849-8ef1f7452095",
        target: "#hubspotForm2",
      });
    });
  },
};
</script>
